import { randomizeNumber } from "@/utils/dices";

export default {
  name: "dr-dice",
  props: {
    number: {
      type: Number,
      required: true
    },
    big: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      randomInterval: undefined,
      diceNumber: this.number
    };
  },
  watch: {
    loading() {
      if (this.loading) {
        const interval = 100;
        this.randomInterval = setInterval(() => {
          this.diceNumber = randomizeNumber();
        }, interval);
      } else {
        clearInterval(this.randomInterval);
        this.diceNumber = this.number;
      }
    }
  },
  computed: {
    size() {
      let size = "small";

      if (this.big) {
        size = "large";
      }

      return size;
    },
    isReverse() {
      let isReverse = false;

      if (this.big) {
        isReverse = true;
      }

      return isReverse;
    }
  }
};
